/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { TemplatePortal } from '@angular/cdk/portal';
import { Directive, Input, Optional, TemplateRef, ViewContainerRef } from '@angular/core';
import { of$ } from '@gh/rx';
import { isNil } from 'lodash';
import { Observable } from 'rxjs';
import { WizardStepBeforeNextDirective } from './wizard-step-before-next.directive';

@Directive({
  selector: '[ghWizardStep]',
})
export class WizardStepDirective extends TemplatePortal<any> {
  @Input('ghWizardStep') name: string;
  @Input() next: string;
  @Input() disabled: boolean = false;

  constructor(public templateRef: TemplateRef<any>,
              viewContainerRef: ViewContainerRef,
              @Optional() private beforeNext?: WizardStepBeforeNextDirective) {
    super(templateRef, viewContainerRef);
  }

  validate(): Observable<boolean> {
    const { beforeNext } = this;
    return isNil(beforeNext) ? of$(true) : beforeNext.validate();
  }

}
